/**
 * Grid Search Explosion Mock
 *
 * Visualises how the number of parameter combinations grows
 * exponentially as you add parameters, making overfitting
 * increasingly likely.
 */

const rows = [
  { params: 2, steps: 10, combos: 100, risk: 'Low', color: '#22c55e' },
  { params: 3, steps: 10, combos: 1000, risk: 'Moderate', color: '#f59e0b' },
  { params: 4, steps: 10, combos: 10000, risk: 'High', color: '#ef4444' },
  { params: 5, steps: 10, combos: 100000, risk: 'Extreme', color: '#dc2626' },
];

const maxLog = Math.log10(100000);

function barWidth(combos: number): string {
  return `${(Math.log10(combos) / maxLog) * 100}%`;
}

export default function GridSearchExplosionMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Parameter Combinations &mdash; Exponential Growth
      </div>
      <div className="platform-mock-body">
        <div style={{ display: 'flex', gap: '0.375rem', fontSize: '0.5625rem', color: '#6b7280', marginBottom: '0.75rem', fontFamily: 'ui-monospace, monospace' }}>
          <span style={{ width: 80 }}>Params</span>
          <span style={{ width: 60 }}>Steps</span>
          <span style={{ flex: 1 }}>Combinations</span>
          <span style={{ width: 70, textAlign: 'right' }}>Overfit Risk</span>
        </div>
        {rows.map((r) => (
          <div key={r.params} style={{ display: 'flex', alignItems: 'center', gap: '0.375rem', marginBottom: '0.5rem' }}>
            <span style={{ width: 80, fontSize: '0.6875rem', color: '#e5e7eb', fontWeight: 600, fontFamily: 'ui-monospace, monospace' }}>
              {r.params} params
            </span>
            <span style={{ width: 60, fontSize: '0.5625rem', color: '#9ca3af', fontFamily: 'ui-monospace, monospace' }}>
              &times;{r.steps}
            </span>
            <div style={{ flex: 1, position: 'relative', height: 20 }}>
              <div style={{
                height: '100%',
                width: barWidth(r.combos),
                background: `${r.color}22`,
                border: `1px solid ${r.color}44`,
                borderRadius: 3,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: '0.375rem',
              }}>
                <span style={{ fontSize: '0.5625rem', fontWeight: 700, color: r.color, fontFamily: 'ui-monospace, monospace' }}>
                  {r.combos.toLocaleString()}
                </span>
              </div>
            </div>
            <span style={{ width: 70, textAlign: 'right', fontSize: '0.5625rem', fontWeight: 600, color: r.color }}>
              {r.risk}
            </span>
          </div>
        ))}
        <div style={{ fontSize: '0.5rem', color: '#6b7280', marginTop: '0.5rem', fontStyle: 'italic' }}>
          Each additional parameter multiplies the search space by the number of steps
        </div>
      </div>
      <div className="platform-mock-caption">
        With 10 steps per parameter, adding a single parameter multiplies combinations by 10&times;.
      </div>
    </div>
  );
}
